import React, { ReactNode } from "react"
import styled from "styled-components"

type ButtonProps = {
  style?: React.CSSProperties
  onClick?: () => void
}

const ShareButton: React.FC<ButtonProps> = ({ onClick, style }) => {
  return (
    <Button
      onClick={onClick}
      style={{
        ...style,
        display: "flex",
      }}
    >
      <svg
        width="23"
        height="25"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.19342 6.49326C5.06783 6.41419 4.93991 6.34209 4.80502 6.27464C4.67013 6.21185 4.53058 6.15603 4.38638 6.10486C4.06078 6.0002 3.71191 5.94438 3.35375 5.94438C2.94906 5.94438 2.56066 6.01648 2.20249 6.14672C2.04667 6.20487 1.90247 6.26999 1.7606 6.34907C1.47453 6.50024 1.21172 6.70025 0.983796 6.92585C0.869834 7.03982 0.765175 7.16308 0.667493 7.29332C0.616327 7.36077 0.56516 7.43287 0.52097 7.50729C0.448872 7.6166 0.390728 7.72591 0.330258 7.84453C0.283743 7.94221 0.241879 8.04222 0.204667 8.14455C0.167455 8.25386 0.132568 8.36783 0.102333 8.48644C0.0930303 8.52365 0.0860531 8.56551 0.0767501 8.6097C0.0558182 8.68878 0.0418636 8.77018 0.0348863 8.85391C0.0255833 8.89577 0.0232576 8.93764 0.0186061 8.9795C0.0139545 9.00974 0.00930303 9.03764 0.00930303 9.06788C0.00465151 9.14463 0 9.21905 0 9.30046C0 9.32139 1.064e-07 9.34697 0.00465163 9.3679C0.00465163 9.51442 0.0162803 9.65862 0.0395379 9.8098C0.0395379 9.81445 0.0395379 9.8191 0.0395379 9.8191C0.048841 9.87724 0.0558183 9.93771 0.0697728 9.99586C0.0744244 10.0168 0.0790758 10.0377 0.0860531 10.0587C0.209318 10.5936 0.460501 11.0797 0.802387 11.4797C1.28382 12.0495 1.94434 12.4542 2.69556 12.5984C2.74207 12.6077 2.78393 12.6147 2.83045 12.6147C2.88859 12.6263 2.94906 12.6309 3.01186 12.6402C3.05837 12.6449 3.10954 12.6495 3.15838 12.6519H3.19792C3.24909 12.6565 3.30258 12.6565 3.35375 12.6565C3.41654 12.6565 3.47934 12.6565 3.53981 12.6472C3.58167 12.6472 3.61888 12.6472 3.66307 12.6426C3.67238 12.6426 3.684 12.6379 3.69331 12.6379C3.80262 12.6286 3.91193 12.6123 4.02124 12.5914C4.07938 12.5798 4.1352 12.5612 4.19335 12.5495C4.30266 12.5193 4.40499 12.4914 4.50965 12.4519C4.71664 12.3751 4.91433 12.2798 5.10039 12.1681C5.2725 12.0588 5.43763 11.9355 5.5888 11.8006C5.63066 11.7634 5.66788 11.7285 5.70742 11.6913L9.90774 14.2101V15.2428C9.90774 17.3127 11.7963 18.9547 13.9453 18.5337C15.2477 18.2756 16.3036 17.222 16.5594 15.9196C16.9804 13.7729 15.3407 11.8797 13.2685 11.8797C12.3498 11.8797 11.5218 12.2518 10.9148 12.8496L6.71214 10.3261L6.6633 10.2959L6.57725 10.2447C6.66563 9.94469 6.71214 9.62839 6.71214 9.30046C6.71214 8.97252 6.66563 8.65622 6.57725 8.3562L6.71214 8.27712L10.9171 5.75135C11.6637 6.49326 12.7568 6.87701 13.9243 6.65839C15.2361 6.40954 16.2943 5.35829 16.5571 4.05587C17.0292 1.70685 15.0337 -0.344472 12.694 0.0485813C11.4497 0.255574 10.4171 1.19053 10.0543 2.4069C9.84727 3.08602 9.8775 3.72328 10.0496 4.30937L5.70742 6.90725C5.55159 6.75375 5.37948 6.61653 5.19342 6.49326Z"
          fill="white"
        />
      </svg>
    </Button>
  )
}

export { ShareButton }

const Button = styled.button`
  border-radius: 50%;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;

  &:active {
    transform: scale(1.2);
  }

  svg > path {
    transition: fill 0.4s ease-in-out;
  }
`
